import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleIcon, MicrosoftIcon, AppleIcon, SlackIcon } from './AuthIcons';
import { useAuth } from './AuthContext';
export function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await login(email, password);
      window.location.href = '/';
    } catch (error) {
      console.error('Error signing in:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSocialSignIn = async (provider: string) => {
    setIsLoading(true);
    try {
      const socialEmail = `user@${provider.toLowerCase()}.com`;
      await login(socialEmail, 'password');
      window.location.href = '/';
    } catch (error) {
      console.error('Error with social sign in:', error);
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-139">
      <div className="max-w-md w-full" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/ssm8opUN7FjpcwsqK5Tnq3/accrue_logo.png" alt="Accrue" className="h-32 mx-auto mb-12" data-id="element-142" />
          <h1 className="text-4xl font-bold mb-2" data-id="element-143">Sign In</h1>
          <p className="text-gray-600" data-id="element-144">Welcome back to the MGA Portal</p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-145">
          <div className="mb-8" data-id="element-146">
            <h2 className="text-2xl font-semibold mb-6" data-id="element-147">
              Sign in to your account
            </h2>
            <form onSubmit={handleSignIn} data-id="element-148">
              <div className="mb-4" data-id="element-149">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-150">
                  Email
                </label>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" className="w-full p-3 border border-gray-300 rounded-md" required data-id="element-151" />
              </div>
              <div className="mb-6" data-id="element-152">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-153">
                  Password
                </label>
                <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md" required data-id="element-154" />
                <div className="mt-1 text-right" data-id="element-155">
                  <a href="#" className="text-sm text-blue-600 hover:text-blue-800" data-id="element-156">
                    Forgot password?
                  </a>
                </div>
              </div>
              <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition duration-150 ease-in-out" disabled={isLoading} data-id="element-157">
                {isLoading ? 'Processing...' : 'Sign in'}
              </button>
            </form>
          </div>
          <div className="relative mb-6" data-id="element-158">
            <div className="absolute inset-0 flex items-center" data-id="element-159">
              <div className="w-full border-t border-gray-300" data-id="element-160"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-161">
              <span className="px-2 bg-white text-gray-500" data-id="element-162">
                Or continue with
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3" data-id="element-163">
            <button onClick={() => handleSocialSignIn('google')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-164">
              <GoogleIcon data-id="element-165" />
            </button>
            <button onClick={() => handleSocialSignIn('microsoft')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-166">
              <MicrosoftIcon data-id="element-167" />
            </button>
            <button onClick={() => handleSocialSignIn('apple')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-168">
              <AppleIcon data-id="element-169" />
            </button>
            <button onClick={() => handleSocialSignIn('slack')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-170">
              <SlackIcon data-id="element-171" />
            </button>
          </div>
        </div>
        <div className="text-center" data-id="element-172">
          <p className="text-gray-600" data-id="element-173">
            Don't have an account?{' '}
            <a href="/signup" className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-174">
              Sign up
            </a>
          </p>
        </div>
      </div>
    </div>;
}